<script setup>
import { ref, computed } from 'vue'
import Icon from '@/components/shell/Icon.vue'
import { store } from '@/store/appStore.js'
const selectedId = ref(null)
const isPharmacyRole = computed(() => store.state.role === 'pharmacy')
const pharmacies = computed(() => store.data.pharmacies.value)
const active = computed(() => isPharmacyRole.value ? store.activePharmacy.value : pharmacies.value.find(p=>p.customerId===selectedId.value)||pharmacies.value[0])
const myOrders = computed(() => store.data.orders.value.filter(o=>o.customerId===active.value?.customerId))
</script>
<template>
  <div>
    <div class="card module-header"><span class="eyebrow">Module 1 — Pharmacy Profile</span><h2>{{ active?.pharmacyName }}</h2></div>
    <div v-if="!isPharmacyRole" class="card" style="padding:14px 20px;margin-bottom:16px;">
      <label class="cell-muted" style="font-size:12px;margin-right:8px;">Viewing profile for:</label>
      <select class="filter-select" :value="active?.customerId" @change="selectedId=$event.target.value">
        <option v-for="p in pharmacies" :key="p.customerId" :value="p.customerId">{{ p.pharmacyName }}</option>
      </select>
    </div>
    <div class="split-2col" v-if="active">
      <div class="card" style="padding:20px;"><div class="eyebrow" style="margin-bottom:14px;">Identity & Licensing</div>
        <dl style="display:grid;grid-template-columns:auto 1fr;gap:8px 16px;margin:0;font-size:13px;">
          <dt class="cell-muted">Customer ID</dt><dd style="margin:0" class="cell-strong">{{ active.customerId }}</dd>
          <dt class="cell-muted">Owner</dt><dd style="margin:0">{{ active.ownerName }}</dd>
          <dt class="cell-muted">Drug License</dt><dd style="margin:0">{{ active.drugLicenseNo }}</dd>
          <dt class="cell-muted">Category</dt><dd style="margin:0">{{ active.category }}</dd>
          <dt class="cell-muted">Potential</dt><dd style="margin:0"><span class="tier-badge" :class="active.potentialClassification">{{ active.potentialClassification }}</span></dd>
        </dl>
      </div>
      <div class="card" style="padding:20px;"><div class="eyebrow" style="margin-bottom:14px;">Contact — OTP Verified</div>
        <dl style="display:grid;grid-template-columns:auto 1fr;gap:8px 16px;margin:0;font-size:13px;">
          <dt class="cell-muted">Mobile 1</dt><dd style="margin:0">{{ active.mobile1 }}</dd>
          <dt class="cell-muted">Mobile 2</dt><dd style="margin:0">{{ active.mobile2||'—' }}</dd>
          <dt class="cell-muted">Email 1</dt><dd style="margin:0;word-break:break-all">{{ active.email1 }}</dd>
          <dt class="cell-muted">OTP Status</dt><dd style="margin:0"><span class="otp-check" :class="active.otpVerified?'verified':'pending'"><Icon :name="active.otpVerified?'shield':'alert'" :size="13" />{{ active.otpVerified?'Verified':'Pending' }}</span></dd>
        </dl>
      </div>
      <div class="card" style="padding:20px;"><div class="eyebrow" style="margin-bottom:14px;">Address & Territory</div>
        <dl style="display:grid;grid-template-columns:auto 1fr;gap:8px 16px;margin:0;font-size:13px;">
          <dt class="cell-muted">Address</dt><dd style="margin:0">{{ active.address }}</dd>
          <dt class="cell-muted">City</dt><dd style="margin:0">{{ active.city }}</dd>
          <dt class="cell-muted">Pincode</dt><dd style="margin:0">{{ active.pincode }}</dd>
          <dt class="cell-muted">Territory</dt><dd style="margin:0">{{ active.territory }}</dd>
          <dt class="cell-muted">Sales Exec</dt><dd style="margin:0">{{ active.assignedSalesExec }}</dd>
        </dl>
      </div>
      <div class="card" style="padding:20px;"><div class="eyebrow" style="margin-bottom:14px;">Business Profiling</div>
        <dl style="display:grid;grid-template-columns:auto 1fr;gap:8px 16px;margin:0;font-size:13px;">
          <dt class="cell-muted">Daily Footfall</dt><dd style="margin:0">{{ active.dailyFootfall }}</dd>
          <dt class="cell-muted">Monthly Footfall</dt><dd style="margin:0">{{ active.monthlyFootfall.toLocaleString() }}</dd>
          <dt class="cell-muted">Potential Score</dt><dd style="margin:0">{{ active.potentialScore }} / 100</dd>
          <dt class="cell-muted">Orders placed</dt><dd style="margin:0">{{ myOrders.length }}</dd>
        </dl>
      </div>
    </div>
  </div>
</template>
